
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Partnership Form page (template key kept as commercial_proposal; the H1 read
// "Partnership Details" from 2026-09-04 to 2026-09-09, Bill): the H1,
// a one-line canonical intro, and the embedded form. The page fills the
// viewport and the form frame takes the remaining height, so the only
// scrollbar is the Google Doc's own (2026-09-03).
export function CommercialProposal(props: PageTemplateProps) {
    return <BasePage {...props} fullWidthIntro fillViewport />;
}
